import ErrorMessage from './ErrorMessage'
import * as React from 'react'
import { Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

const StepThree = (props) => {
  const MAP_FIELD_ERRORS = {
    email: I18n.t('form_input_invalid_email')
  }
  const { dataRegister = {} } = props

  const inputEditEmail = React.useRef(null)
  const [modal, setModal] = React.useState(false)
  const [isEditEmail, setIsEditEmail] = React.useState(false)
  const [textEditableEmail, setTextEditableEmail] = React.useState(I18n.t('signup_step_three_check_email_prompt'))
  const [errors, setErrors] = React.useState({})
  const [currentEmail, setCurrentEmail] = React.useState('')

  const toggle = () => {
    setIsEditEmail(false)
    setModal(!modal)
  }

  React.useEffect(() => {
    if (dataRegister.email)
      setCurrentEmail(dataRegister.email)
  }, [dataRegister.email])

  const changeEmail = () => {
    if (isEditEmail) {
      // validate email
      const validateErrors = validateFields({ email: inputEditEmail.current.value })
      if (Object.keys(validateErrors).length === 0) {
        setErrors({})
        let newEmail = currentEmail

        if (inputEditEmail.current.value) {
          newEmail = inputEditEmail.current.value
          props.changeEmail(newEmail)
        }

        setCurrentEmail(newEmail)

        setTextEditableEmail(I18n.t('signup_step_three_check_email_prompt'))
        setIsEditEmail(false)
      } else {
        setErrors(validateErrors)
      }
    } else {
      setTextEditableEmail(I18n.t('dashboard_save-and-send-email'))
      setIsEditEmail(true)
      setTimeout(() => {
        inputEditEmail.current.focus()
      }, 1)
    }
  }

  const validateFields = (values) => {
    const errors = {}
    if (values.email !== '' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = MAP_FIELD_ERRORS.email
    }

    return errors
  }

  const handleSendEmailAgain = () => {
    const validateErrors = validateFields({ email: inputEditEmail.current.value })

    if (Object.keys(validateErrors).length === 0) {
      setErrors({})
      let newEmail = currentEmail

      if (inputEditEmail.current.value) {
        newEmail = inputEditEmail.current.value
      }

      props.changeEmail(newEmail)
      setCurrentEmail(newEmail)
      setModal(!modal)
    } else {
      setErrors(validateErrors)
    }
  }

  return (
    <div className='form-window'>
      {modal ? (
        <div className='modal'>
          <div className='modal-content'>
            <div className='modal-header'>
              <div className='modal-title'>{I18n.t('signup_step_three_no_email_title')}</div>
              <div className='close' onClick={toggle}>
                <i className='fa fa-times' color='grey'></i>
              </div>
            </div>
            <div className='modal-body'>
              <div className='item-container'>
                <div>
                  <div className='item'>
                    <div>1</div>
                  </div>
                </div>
                <div className='item-text-container'>
                  <div className='item-title'>{I18n.t('signup_step_three_spam_title')}</div>
                  <div className='item-subtitle'>{I18n.t('signup_step_three_spam_subtitle')}</div>
                </div>
              </div>
              <div className='item-container'>
                <div>
                  <div className='item'>
                    <div>2</div>
                  </div>
                </div>
                <div className='item-text-container'>
                  <div className='item-title'>{I18n.t('signup_step_three_check_email_title')}</div>
                  <div className='item-subtitle'>{I18n.t('signup_step_three_check_email_subtitle')}</div>
                  <div>
                    <input ref={inputEditEmail} disabled={!isEditEmail} placeholder={currentEmail} />
                    <Button className='change-email' onClick={changeEmail}>
                      <i className='fa fa-pencil pr-2' />
                      {textEditableEmail}
                    </Button>
                    {errors.email ? <ErrorMessage text={errors.email} /> : null}
                  </div>
                </div>
              </div>
              <div className='item-container'>
                <div>
                  <div className='item'>
                    3
                  </div>
                </div>
                <div className='item-text-container'>
                  <div className='item-title'>{I18n.t('signup_step_three_send_email_title')}</div>
                  <div className='item-subtitle'>
                    {I18n.t('signup_step_three_send_email_subtitle')}
                  </div>
                  <Button className='email-button' onClick={handleSendEmailAgain}>
                    {I18n.t('signup_step_three_send_email_action')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className='header-three'>
        <div className='title'>{I18n.t('signup_step_three_send_verify_title')}</div>
      </div>
      <div className='text-container'>
        <div className='paragraph-container'>
          <div className='verify-text'>
            {I18n.t('signup_step_three_send_verify_text_1')}
            <br/>
            <span className='verify-text-highlight'> {currentEmail} </span>
            <br/>
            {I18n.t('signup_step_three_send_verify_text_2')}
          </div>
        </div>
        <div className='paragraph-container'>
          <div className='verify-text'>{I18n.t('signup_step_three_send_verify_subtitle')}</div>
        </div>
        <div className='paragraph-container'>
          <div className='verify-text'>
            {I18n.t('signup_step_three_send_verify_text_3')}
            <br/>
            <div onClick={toggle} className='verify-text-highlight verify-text-button'>
              {I18n.t('signup_step_three_send_verify_action')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepThree
